import { getUserNotificationsAction, updateNotificationsAction } from './actions';
import { listReducer, defaultListParams, defaultEntityParams } from '../../utils/crudUtils';

export const key = 'Notifications';

export const initialState = {
  userNotifications: defaultListParams,
  profileNotifications: defaultEntityParams,
};

const notificationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getUserNotificationsAction.TRIGGER:
    case getUserNotificationsAction.SUCCESS:
    case getUserNotificationsAction.FAILURE:
      return listReducer(state, type, payload, 'userNotifications');
    case updateNotificationsAction.SUCCESS:
      return {
        ...state,
        userNotifications: {
          ...state.userNotifications,
          data: state.userNotifications.data.filter(d => d?.id !== payload?.id),
          total: state.userNotifications.total - 1,
        },
      };
    default:
      return state;
  }
};

export default notificationsReducer;
